export const RENTAL_PROFILE_SECTIONS = {
  PERSONAL_DETAILS: "personalDetails",
  ABOUT_ME: "aboutMe",
  ADDRESS_HISTORY: "addressHistory",
  EMPLOYMENT: "employment",
  FINANCES: "finances",
  IDENTITY_DOCUMENTS: "identityDocuments",
  HOUSEHOLD_PEOPLE: "householdPeople",
  HOUSEHOLD_PETS: "householdPets",
};

export const EMPTY_RENTAL_PROFILE = {
  personalDetails: {
    firstName: "",
    lastName: "",
    dateOfBirth: { day: "", month: "", year: "" },
    phone: "",
    email: "",
  },
  aboutMe: {
    aboutText: "",
    supportingDocument: null,
  },
  addressHistory: {
    currentAddress: null,
    previousAddresses: [],
  },
  employment: {
    employmentType: "",
    companyName: "",
    roleTitle: "",
    startDate: { month: "", year: "" },
    reference: {
      type: "",
      fullName: "",
      email: "",
      phone: "",
    },
  },
  finances: {
    noIncome: false,
    incomeSources: [],
    proofDocuments: [],
  },
  identityDocuments: {
    photoId: null,
    secondId: null,
  },
  householdPeople: {
    liveWithOthers: "yes",
    occupants: [],
  },
  householdPets: {
    dogs: 0,
    cats: 0,
    other: 0,
  },
};

export const mergeRentalProfile = (raw) => {
  const base = JSON.parse(JSON.stringify(EMPTY_RENTAL_PROFILE));
  if (!raw || typeof raw !== "object") return base;

  return {
    personalDetails: { ...base.personalDetails, ...raw.personalDetails },
    aboutMe: { ...base.aboutMe, ...raw.aboutMe },
    addressHistory: {
      ...base.addressHistory,
      ...raw.addressHistory,
      previousAddresses: Array.isArray(raw.addressHistory?.previousAddresses)
        ? raw.addressHistory.previousAddresses
        : base.addressHistory.previousAddresses,
    },
    employment: {
      ...base.employment,
      ...raw.employment,
      startDate: {
        ...base.employment.startDate,
        ...raw.employment?.startDate,
      },
      reference: {
        ...base.employment.reference,
        ...raw.employment?.reference,
      },
    },
    finances: {
      ...base.finances,
      ...raw.finances,
      incomeSources: Array.isArray(raw.finances?.incomeSources)
        ? raw.finances.incomeSources
        : base.finances.incomeSources,
      proofDocuments: Array.isArray(raw.finances?.proofDocuments)
        ? raw.finances.proofDocuments
        : base.finances.proofDocuments,
    },
    identityDocuments: {
      ...base.identityDocuments,
      ...raw.identityDocuments,
    },
    householdPeople: { ...base.householdPeople, ...raw.householdPeople },
    householdPets: { ...base.householdPets, ...raw.householdPets },
  };
};

export const ALL_RENTAL_PROFILE_SECTIONS = [
  RENTAL_PROFILE_SECTIONS.PERSONAL_DETAILS,
  RENTAL_PROFILE_SECTIONS.ABOUT_ME,
  RENTAL_PROFILE_SECTIONS.ADDRESS_HISTORY,
  RENTAL_PROFILE_SECTIONS.EMPLOYMENT,
  RENTAL_PROFILE_SECTIONS.FINANCES,
  RENTAL_PROFILE_SECTIONS.IDENTITY_DOCUMENTS,
  RENTAL_PROFILE_SECTIONS.HOUSEHOLD_PEOPLE,
  RENTAL_PROFILE_SECTIONS.HOUSEHOLD_PETS,
];

export const isRenterProfileComplete = (profile) =>
  ALL_RENTAL_PROFILE_SECTIONS.every((section) =>
    isSectionComplete(section, profile)
  );

export const isSectionComplete = (section, profile) => {
  if (!profile) return false;
  switch (section) {
    case RENTAL_PROFILE_SECTIONS.PERSONAL_DETAILS: {
      const p = profile.personalDetails;
      return Boolean(p.firstName?.trim() && p.lastName?.trim() && p.phone?.trim());
    }
    case RENTAL_PROFILE_SECTIONS.ABOUT_ME:
      return Boolean(profile.aboutMe?.aboutText?.trim());
    case RENTAL_PROFILE_SECTIONS.ADDRESS_HISTORY:
      return Boolean(profile.addressHistory?.currentAddress?.street?.trim());
    case RENTAL_PROFILE_SECTIONS.EMPLOYMENT: {
      const e = profile.employment;
      return Boolean(e.employmentType?.trim());
    }
    case RENTAL_PROFILE_SECTIONS.FINANCES: {
      const f = profile.finances;
      if (f.noIncome) return true;
      return f.incomeSources?.length > 0 || f.proofDocuments?.length > 0;
    }
    case RENTAL_PROFILE_SECTIONS.IDENTITY_DOCUMENTS: {
      const id = profile.identityDocuments;
      return Boolean(id.photoId || id.secondId);
    }
    case RENTAL_PROFILE_SECTIONS.HOUSEHOLD_PEOPLE:
      return Boolean(profile.householdPeople?.liveWithOthers);
    case RENTAL_PROFILE_SECTIONS.HOUSEHOLD_PETS:
      return true;
    default:
      return false;
  }
};
